import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getEquipment({page="page=1",term=""}) {
  const res = await getFetch(`/Equipment?term=${term}&${page}`);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeEquipment(form) {
  if (form.name === "") {
    return {
      status: "error",
      message: "عنوان الزامی است!",
    };
  }


  const res = await postFetchWithBody("/Equipment/store", form);
  if (res.status !== "error") {
    return {
      status: "success",
      message: "تجهیز بارگیری با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
async function deleteEquipment(id) {
  const res = await postFetchWithBody(`/Equipment/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { storeEquipment , getEquipment,deleteEquipment};
